module.exports = __webpack_public_path__ + "/img/Crystal-Labeled-mf0VOs.svg";